import { FC, ReactNode } from 'react';
import { Box, Drawer, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  width?: number | string;
  zIndex?: number;
  headerActions?: ReactNode;
}

export const RightDrawer: FC<Props> = ({ open, onClose, children, width = 480, zIndex, headerActions }) => {
  const { t } = useTranslation();

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        ...(zIndex != null && { zIndex }),
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: width },
          maxWidth: '100%',
        },
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, p: 2 }}>
        {headerActions && <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>{headerActions}</Box>}
        <IconButton onClick={onClose} aria-label={t('common.close')}>
          <CloseIcon />
        </IconButton>
      </Box>
      {children}
    </Drawer>
  );
};
